// Historia 148 — construcción de las URL del camino documental de MOS.
//
// Módulo HOJA, sin imports. Dos familias:
//
//  · N1, el endpoint agregador NUEVO: una sola petición devuelve la documentación entera de la
//    fabricación, ya derivada, ya filtrada por permisos y ya ordenada (D1/R7/S31). Jupiter no
//    compone procedencias ni decide visibilidad: pinta lo que recibe.
//
//  · N2-N5, los endpoints documentales que MIC oficina YA usa, a los que MOS añade su contexto en
//    4 query params OPCIONALES y ADITIVOS. Su AUSENCIA total es lo que mantiene el camino de
//    oficina byte a byte igual (S44/D2/R1): si falta uno solo de los cuatro, el servidor no evalúa
//    el gate. Por eso aquí se envían siempre los cuatro, o ninguno.
//
// ⚠️ D4/RN35: el contexto que viaja es el de la procedencia PULSADA, con su `sourceType` y su
// `sourceReferenceId`, no «la del documento». Un mismo documento colgado de dos procedencias se
// pinta dos veces (RN15/S54) y cada aparición actúa sobre la suya.

/** El único identificador documental válido del job: `jobReference.id` (corrección as-is nº1). */
const buildFabricationDocumentsUrl = (fabricationOrderId, jobReferenceId) =>
  'mos/fabricationOrder/' + fabricationOrderId + '/job/' + jobReferenceId + '/documents'

/**
 * Los 4 query params del contexto MOS, en el orden del contrato. Se emiten los cuatro juntos.
 * @param {{fabricationOrderId: (string|number), jobReferenceId: (string|number), sourceType: string, sourceReferenceId: (string|number)}} context
 * @returns {string} La cadena de consulta, empezando por `?`
 */
const buildMosDocumentContextQuery = ({ fabricationOrderId, jobReferenceId, sourceType, sourceReferenceId }) =>
  '?fabricationOrderId=' + encodeURIComponent(fabricationOrderId) +
  '&jobReferenceId=' + encodeURIComponent(jobReferenceId) +
  '&sourceType=' + encodeURIComponent(sourceType) +
  '&sourceReferenceId=' + encodeURIComponent(sourceReferenceId)

/** N2 — descarga. El `uuid` es el del documento; el contexto, el de la aparición pulsada. */
const buildMosDocumentDownloadUrl = (documentUUID, context) =>
  'document/file/download/' + documentUUID + buildMosDocumentContextQuery(context)

/**
 * N3 — alta. El destino real de escritura son los path params, y la TAREA 0 del lote 3 de Sun
 * exige que coincidan con el declarado: se construyen del MISMO contexto, nunca de dos fuentes.
 */
const buildMosDocumentCreateUrl = (context) =>
  'document/create/' + context.sourceType + '/' + context.sourceReferenceId +
  buildMosDocumentContextQuery(context)

/** N4 — edición de metadatos. El `uuid` viaja en el cuerpo; aquí solo el contexto. */
const buildMosDocumentUpdateUrl = (context) =>
  'document/update' + buildMosDocumentContextQuery(context)

/** N5 — borrado. Como N3, path params y contexto salen del MISMO origen (TAREA 0). */
const buildMosDocumentDeleteUrl = (documentId, context) =>
  'document/delete/' + context.sourceType + '/' + context.sourceReferenceId + '/' + documentId +
  buildMosDocumentContextQuery(context)

export {
  buildFabricationDocumentsUrl,
  buildMosDocumentContextQuery,
  buildMosDocumentDownloadUrl,
  buildMosDocumentCreateUrl,
  buildMosDocumentUpdateUrl,
  buildMosDocumentDeleteUrl
}
